import { getCustomServiceLayerHeader } from 'additiv-services/setup';
import Service from '../../additiv-services';
import {
    CUSTOM_SERVICE_LAYER_SERVICES,
    getCustomServiceLayerBaseUrl,
} from '../constants';

class CustomCommonService extends Service {
    static #baseServiceUrl = getCustomServiceLayerBaseUrl(
        CUSTOM_SERVICE_LAYER_SERVICES.COMMON,
    );

    static async getProductsConfiguration({ language, contactId }) {
        let queryString = `language=${language}`;

        if (contactId) {
            queryString += `&contactId=${contactId}`;
        }

        return Service.getRequest(
            `${this.#baseServiceUrl}/campaign/configuration?${queryString}`,
            {
                isSecure: true,
                cache: false,
                axiosSetup: { headers: getCustomServiceLayerHeader() },
            },
        );
    }

    static infraTest({ timeout }) {
        return Service.getRequest(
            `${this.#baseServiceUrl}/testDelay?seconds=${timeout}`,
            {
                isSecure: true,
                axiosSetup: { headers: getCustomServiceLayerHeader() },
            },
        );
    }
}

export default CustomCommonService;
